module.exports = __webpack_public_path__ + "static/img/login.aa7411b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login.png
// module id = Uwr+
// module chunks = 101